import {
    DETAIL_DASHBOARD_API_SUCCESS,
    DETAIL_DASHBOARD_API_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    data: {},
    //  activeRoute: "",
};

const Detail_Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case DETAIL_DASHBOARD_API_SUCCESS:
            return {
                ...state,
                data: action.payload.OK
            };

        case DETAIL_DASHBOARD_API_FAIL:
            return {
                ...state,
                apiDataError: action.payload.error
            };

        default:
            return state;
    }
}

export default Detail_Dashboard;